import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';

/**
 * Fetches audit logs for a specific approval person invoice
 * @param {string|number} invoiceId - The invoice id
 * @returns {Promise} - API response containing audit logs
 */
export const getApprovalPersonInvoiceAuditLogs = async (invoiceId) => {
  try {
    const response = await apiClient.get(
      `/approvalPersonInvoiceManagement/invoice/audit-logs/${invoiceId}`
    );

    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};
